import { useSelector } from "react-redux";
import { sumOfRecordCounts, sumOfRecordCountsWithoutDecimal } from "../../../helper/utility";
import { Constants } from "../../Common/Constants";
import AreaGraph from "../../Common/Graphs/AreaGraph";

const Weekly = () => {
  // const { workoutanalytics } = useSelector((store) => store.Reports);
  const totalReps = useSelector((store) => store.WorkOutAnalyticsReportReducer.exerciseCategoryWiseWorkoutCompletedReport.reps);
  const totalWeightsLifted = useSelector((store) => store.WorkOutAnalyticsReportReducer.exerciseCategoryWiseWorkoutCompletedReport.totalWeightLifted);

  const sumOfTotalReps = sumOfRecordCountsWithoutDecimal(totalReps);
  const sumOfTotalWeightsLifted = sumOfRecordCounts(totalWeightsLifted);

  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={workoutanalytics?.genderWisetotalRepsExerciseCategoryId}
          data={totalReps}
          // title={Constants.totalReps}
          title={`${Constants.totalReps} ${sumOfTotalReps}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={workoutanalytics?.genderWisetotalWeightLiftedExerciseCategoryId}
          data={totalWeightsLifted}
          title={`${Constants.totalWeightLifted} ${sumOfTotalWeightsLifted}`}
          format=""
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Weekly;
